import React from 'react';
import { useAppSelector } from '../../../redux/hooks';
import FormBuilderGroupDetails from './form-builder-group-details.component';
import FormBuilderHierarchySectionDetails from './form-builder-hierarchy-section-details.component';
import { selectSelectedGroup } from '../../../redux/slices/form-builder-slice';

const FormBuilderGroupDetailsWrapper = () => {
  const { id } = useAppSelector(selectSelectedGroup);

  if (String(id).includes('HIERARCHIES')) {
    return <FormBuilderHierarchySectionDetails />;
  }

  return <FormBuilderGroupDetails />;
};

export default React.memo(FormBuilderGroupDetailsWrapper);
